import { isElementWithViewport } from "./utils.js";

export class Magnet extends HTMLElement {
  #intersectionObserver: IntersectionObserver;

  get targetSelector() {
    return this.getAttribute("target-selector");
  }

  get textPosition() {
    return this.getAttribute("text-position");
  }

  get parentWithViewport() {
    return this.getAttribute("parent-with-viewport");
  }

  get parentToObserve() {
    return this.getAttribute("parent-to-observe");
  }

  constructor() {
    super();

    const parentWithViewportElement =
      this.parentWithViewport && this.closest(this.parentWithViewport);
    const root =
      parentWithViewportElement &&
      isElementWithViewport(parentWithViewportElement)
        ? parentWithViewportElement.getViewportElement()
        : isElementWithViewport(this.parentElement)
          ? this.parentElement.getViewportElement()
          : null;

    // Setup IntersectionObserver
    this.#intersectionObserver = new IntersectionObserver(
      this.#handleIntersection,
      {
        root,
        rootMargin: "100%",
        threshold: 0.9,
      },
    );
  }

  connectedCallback() {
    const observedParentElement =
      this.parentToObserve && this.closest(this.parentToObserve);
    this.#intersectionObserver.observe(observedParentElement || this);

    if (this.textPosition == "bottom") {
      const maxBlockSize = this.previousElementSibling?.getElementsByClassName(
        "group-gallery-item__bounding-box",
      )[0]?.clientHeight;
      this.style.maxBlockSize = `${maxBlockSize}px`;
    }
  }

  #handleIntersection = (entries: IntersectionObserverEntry[]) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) return;
      if (!this.targetSelector) return;
      const targets = document.querySelectorAll(this.targetSelector);
      for (const target of targets) {
        if (this.contains(target)) return;
        this.appendChild(target);
        target.removeAttribute("disabled");
      }
    }
  };

  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
  }
}

"customElements" in window &&
  customElements.get("ws-magnet") === undefined &&
  customElements.define("ws-magnet", Magnet);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-magnet": Magnet;
  }
}
